import { useCallback } from "react";
import { Button, Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { MdOpenInNew } from "react-icons/md";
// src/modules/AppWrapper2/components/AppNav/components/AppItem.tsx
function AppItem({ active = false, color, description, icon, link, name, onClick }) {
	const handleClick = useCallback((e) => {
		e.preventDefault();
		if (!active) onClick();
	}, [onClick, active]);
	return /* @__PURE__ */ jsx("a", {
		className: classnames({ "cursor-not-allowed": active }),
		href: link,
		onClick: handleClick,
		children: /* @__PURE__ */ jsx(Button, {
			className: classnames("group h-full justify-start", { "bg-main-faded": active }),
			disabled: active,
			subtle: true,
			fullWidth: true,
			children: /* @__PURE__ */ jsxs("div", {
				className: "gap-x-base inline-flex h-full w-full text-left",
				children: [/* @__PURE__ */ jsx("div", {
					className: classnames("h-xl sm:h-xxl sm:w-xxl flex w-xl shrink-0 items-center justify-center", { "opacity-50": active }),
					style: { color },
					children: /* @__PURE__ */ jsx(Icon, {
						className: "app-icon-enamel",
						Icon: icon,
						size: "lg"
					})
				}), /* @__PURE__ */ jsxs("div", {
					className: "flex w-full flex-col",
					children: [/* @__PURE__ */ jsxs("div", {
						className: "inline-flex items-baseline justify-between",
						children: [/* @__PURE__ */ jsx("p", {
							className: classnames(active ? "text-color-subtle" : "text-color group-hover:text-color-strong group-active:text-color-subtle transition", "font-medium"),
							children: name
						}), !active && /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("a", {
							onClick: (event) => {
								event.stopPropagation();
								event.preventDefault();
								window.open(link, "_blank");
							},
							children: /* @__PURE__ */ jsx(Button, {
								subtle: true,
								variant: "neutral",
								children: /* @__PURE__ */ jsx(Icon, {
									size: "sm",
									Icon: MdOpenInNew
								})
							})
						}) })]
					}), /* @__PURE__ */ jsx("p", {
						className: classnames(active ? "text-color-subtle opacity-70" : "text-color-subtle group-hover:text-color-strong group-active:text-color-subtle", "text-sm font-normal"),
						children: description
					})]
				})]
			})
		})
	});
}
export { AppItem };

//# sourceMappingURL=AppItem.js.map